import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-zinc-500" data-testid="auth-loading">
        Chargement...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
